var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgToday(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_22615_107627)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.80867 10.6447C8.48169 10.6447 10.6486 8.47779 10.6486 5.80477C10.6486 3.13175 8.48169 0.964844 5.80867 0.964844C3.13566 0.964844 0.96875 3.13175 0.96875 5.80477C0.96875 8.47779 3.13566 10.6447 5.80867 10.6447Z",
    stroke: "#FAA11C",
    strokeWidth: 0.967985,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.80859 2.90039V5.80435L7.74456 6.77233",
    stroke: "#FAA11C",
    strokeWidth: 0.967985,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_22615_107627"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 11.6158,
    height: 11.6158,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToday);
export default __webpack_public_path__ + "static/media/today.2eb7a7eb926e6ca6b73621f28f27e69f.svg";
export { ForwardRef as ReactComponent };